import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import InsuranceConventionContainer from './InsuranceConventionContainer';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { areas } from 'constants/areas';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useReactiveVar } from '@apollo/client';
import { conventionNameVar } from '../variables';
import { ADMIN_INSURANCE_CONVENTIONS_READ } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const productId = match.params.id && getInt(match.params.id);
  const { t } = useTranslation();

  const conventionName = useReactiveVar(conventionNameVar);
  const onRedirect = useCallback(
    id => {
      historyContext.push(`/insuranceConventions/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>{`${t('InsuranceConventions.Title')}:${
          conventionName ? ` ${conventionName}` : ' - / -'
        }`}</Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton
          tooltip={t('Tooltips.InsuranceConventions.BackToList')}
          color='transparent'
          onClick={() => historyContext.push(`/insuranceConventions`)}
        >
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_INSURANCE_CONVENTIONS_READ}>
        <InsuranceConventionContainer productId={productId} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
